query ApprovalTestResults(
  $filter: ApprovalTestResultFilter
  $orderBy: [ApprovalTestResultsOrderBy!]
) {
  approvalTestResults(filter: $filter, orderBy: $orderBy) {
    nodes {
      id
      _rowTimestamp
      testDate
      _fullComment
      comment
      _isCustomTest
      isGlobalTest
      statusType {
        statusType
      }
      _isUpdatable
      _isDeletable
    }
  }
}
